module.exports = {
    showFlowbiteTab(tabInstance, id, forceShow) {
        var _a, _b;
        var _this = tabInstance;
        if (forceShow === void 0) {
            forceShow = false;
        }
        var tab = tabInstance.getTab(id);
        // don't do anything if already active
        if (tab === tabInstance._activeTab && !forceShow) {
            return;
        }
        // hide other tabs
        tabInstance._items.map(function (t) {
            var _a, _b;
            if (t !== tab) {
                (_a = t.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(' '));
                (_b = t.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(' '));
                t.targetEl.classList.add('hidden');
                t.triggerEl.setAttribute('aria-selected', 'false');
            }
        });
        // show active tab
        (_a = tab.triggerEl.classList).add.apply(_a, tabInstance._options.activeClasses.split(' '));
        (_b = tab.triggerEl.classList).remove.apply(_b, tabInstance._options.inactiveClasses.split(' '));
        tab.triggerEl.setAttribute('aria-selected', 'true');
        tab.targetEl.classList.remove('hidden');
        tabInstance.setActiveTab(tab);
        // callback function
        tabInstance._options.onShow(tabInstance, tab);
    },
    initFlowbiteTab($parentEl) {
        if ($parentEl) {
            var Default = {
                defaultTabId: null,
                activeClasses: 'tab__selected',
                inactiveClasses: 'tab__default',
                onShow: function () {},
            };
            var DefaultInstanceOptions = {
                id: $parentEl.id,
                override: true,
            };
            var tabItems = [];
            var activeClasses = $parentEl.getAttribute('data-tabs-active-classes');
            var inactiveClasses = $parentEl.getAttribute('data-tabs-inactive-classes');
            var defaultTabId = null;
            $parentEl.querySelectorAll('[role="tab"]').forEach(function ($triggerEl) {
                var isActive = $triggerEl.getAttribute('aria-selected') === 'true';
                var tab = {
                    id: $triggerEl.getAttribute('data-tabs-target'),
                    triggerEl: $triggerEl,
                    targetEl: document.querySelector($triggerEl.getAttribute('data-tabs-target')),
                };
                tabItems.push(tab);
                if (isActive) {
                    defaultTabId = tab.id;
                }
            });
            // check for existing tab instance
            let existingTabInstance = FlowbiteInstances.instanceExists('Tab', $parentEl.id);

            if (existingTabInstance) {
                return;
            }

            // creates a new instance of the tab or use existing one if it already exists
            let tabInstance = existingTabInstance
                ? existingTabInstance
                : new Tabs(
                      $parentEl,
                      tabItems,
                      {
                          defaultTabId: defaultTabId,
                          activeClasses: activeClasses ? activeClasses : Default.activeClasses,
                          inactiveClasses: inactiveClasses ? inactiveClasses : Default.inactiveClasses,
                      },
                      DefaultInstanceOptions,
                  );

            if (tabInstance) {
                var _this = tabInstance;
                if (tabInstance._items.length && !tabInstance._initialized) {
                    // set the first tab as active if not set by explicitly
                    if (!tabInstance._activeTab) {
                        tabInstance.setActiveTab(tabInstance._items[0]);
                    }
                    // force show the first default tab
                    showFlowbiteTab(tabInstance, tabInstance._activeTab.id, true);
                    // show tab content based on click
                    tabInstance._items.map(function (tab) {
                        tab.triggerEl.addEventListener('click', function (event) {
                            event.preventDefault();
                            showFlowbiteTab(tabInstance, tab.id);
                        });
                    });
                }
            }
        }
    },
    initializeFlowBiteTabs() {
        document.querySelectorAll('[data-tabs-toggle]').forEach(function ($parentEl) {
            initFlowbiteTab($parentEl);
        });
    },
};
